export const parseCurlCommand = (curlCommand) => {
  const result = {
    method: "GET",
    url: "",
    path: "",
    baseUrl: "",
    headers: {},
    body: "",
    queryParams: [],
    bodyType: null,
    formFields: [],
  };

  let command = curlCommand.trim();
  if (command.startsWith("curl ")) {
    command = command.substring(5);
  }

  const urlRegex = /(?:^|\s)(['"]?)((https?):\/\/[^\s'"]+)\1/i;
  const methodRegex = /(?:-X|--request)\s+(['"]?)([A-Z]+)\1/i;
  const headerRegex = /(?:-H|--header)\s+(['"])([^:]+):\s*([^\1]+?)\1/gi;

  const dataRawRegex = /--data-raw\s+(['"])([\s\S]*?)\1/i;
  const dataBinaryRegex = /--data-binary\s+(['"])([\s\S]*?)\1/i;
  const dataRegex = /--data\s+(['"])([\s\S]*?)\1/i;
  const dataShortRegex = /-d\s+(['"])([\s\S]*?)\1/i;

  const formDataRegex = /--data-urlencode\s+(['"]?)([^=]+=[^'"]+)\1/gi;
  const formFieldRegex = /(?:-F|--form)\s+(['"])([^=]+)=([^\1]+?)\1/gi;

  const urlMatch = command.match(urlRegex);
  if (urlMatch && urlMatch[2]) {
    result.url = urlMatch[2];

    try {
      const urlObj = new URL(result.url);

      // Split out query params
      const searchParams = new URLSearchParams(urlObj.search);
      searchParams.forEach((value, key) => {
        result.queryParams.push({
          idapiparams: Math.floor(1000 + Math.random() * 9000),
          key,
          value,
        });
      });

      result.baseUrl = urlObj.origin;

      result.path = urlObj.pathname;

      if (result.queryParams.length > 0) {
        result.url = result.url.split("?")[0];
      }
    } catch {
      const slashIdx = result.url.indexOf("/", result.url.indexOf("//") + 2);
      if (slashIdx !== -1) {
        result.baseUrl = result.url.slice(0, slashIdx);
        result.path = result.url.slice(slashIdx).split("?")[0];
      } else {
        result.baseUrl = result.url;
        result.path = "/";
      }
    }
  }

  const methodMatch = command.match(methodRegex);
  if (methodMatch && methodMatch[2]) {
    result.method = methodMatch[2];
  }

  if (
    !methodMatch &&
    (dataRawRegex.test(command) ||
      dataBinaryRegex.test(command) ||
      dataRegex.test(command) ||
      dataShortRegex.test(command))
  ) {
    result.method = "POST";
  }

  let headerMatch;
  const headers = {};
  while ((headerMatch = headerRegex.exec(command)) !== null) {
    headers[headerMatch[2].trim()] = headerMatch[3].trim();
  }
  result.headers = JSON.stringify(headers, null, 2);

  let formFieldMatch;
  const formDataFields = [];
  while ((formFieldMatch = formFieldRegex.exec(command)) !== null) {
    const key = formFieldMatch[2].trim();
    let value = formFieldMatch[3].trim();
    const isFile = value.startsWith("@");
    if (isFile) value = value.substring(1);
    formDataFields.push({ key, value, type: isFile ? "file" : "text" });
  }

  if (formDataFields.length > 0) {
    result.formFields = formDataFields;
    result.bodyType = "form-data";

    const formDataObj = {};
    formDataFields.forEach((field) => {
      formDataObj[field.key] = field.type === "file" ? `[FILE: ${field.value}]` : field.value;
    });
    result.body = JSON.stringify(formDataObj, null, 2);

    const headersObj = JSON.parse(result.headers);
    if (!headersObj["Content-Type"] && !headersObj["content-type"]) {
      headersObj["Content-Type"] = "multipart/form-data";
      result.headers = JSON.stringify(headersObj, null, 2);
    }
  } else {
    let dataMatch = command.match(dataRawRegex);
    if (!dataMatch) dataMatch = command.match(dataBinaryRegex);
    if (!dataMatch) dataMatch = command.match(dataRegex);
    if (!dataMatch) dataMatch = command.match(dataShortRegex);

    if (dataMatch && dataMatch[2]) {
      const bodyContent = dataMatch[2].trim();
      try {
        const jsonBody = JSON.parse(bodyContent);
        result.body = JSON.stringify(jsonBody, null, 2);
        result.bodyType = "json";
      } catch {
        result.body = bodyContent;
        result.bodyType = "raw";
      }
    }
  }

  let formDataMatch;
  const urlEncodedFields = [];
  while ((formDataMatch = formDataRegex.exec(command)) !== null) {
    const paramPair = formDataMatch[2].split("=");
    if (paramPair.length === 2) {
      urlEncodedFields.push({ key: paramPair[0], value: paramPair[1], type: "text" });
      result.queryParams.push({
        idapiparams: Math.floor(1000 + Math.random() * 9000),
        key: paramPair[0],
        value: paramPair[1],
      });
    }
  }

  if (urlEncodedFields.length > 0 && !result.bodyType) {
    result.bodyType = "x-www-form-urlencoded";
    result.formFields = urlEncodedFields;
  }

  return result;
};
